import { useState, useMemo } from 'react';
import { Link, useParams } from 'react-router-dom';
import logoUtiNeo from '../../../img/logoUtiNeo.png';
import './index.css';

const TipoArquivoLabel = {
    1: 'Protocolo',
    2: 'Fluxograma',
    3: 'Diretriz',
    4: 'Documento',
    5: 'Video',
    6: 'Outro',
    7: 'Link',
};


const MenuLateral = ({ title, conteudo, arquivos, loading }) => {
    const { arquivoID } = useParams();

    const [paginaAtual, setPaginaAtual] = useState(1);
    const itensPorPagina = 10;

    const totalPaginas = Math.ceil(arquivos.length / itensPorPagina);

    const arquivosPaginados = useMemo(() => {
        const inicio = (paginaAtual - 1) * itensPorPagina;
        return arquivos.slice(inicio, inicio + itensPorPagina);
    }, [paginaAtual, arquivos]);

    const gerarPaginas = () => {
        const paginas = [];
        const maxPaginasVisiveis = 3;
        const metade = Math.floor(maxPaginasVisiveis / 2);

        let inicio = Math.max(1, paginaAtual - metade);
        let fim = Math.min(totalPaginas, inicio + maxPaginasVisiveis - 1);

        if (fim - inicio < maxPaginasVisiveis - 1) {
            inicio = Math.max(1, fim - maxPaginasVisiveis + 1);
        }

        for (let i = inicio; i <= fim; i++) {
            paginas.push(i);
        }

        return paginas;
    };

    return (
        <div className="menu-lateral-container">
            <ul id="nav" className="list-group">
                <div className="menu-lateral-box">
                    <div className="menu-lateral-logo">
                        <img src={logoUtiNeo} alt="logo" />
                    </div>
                    <div className="menu-lateral-header">
                        <div className="menu-lateral-title">
                            <h5>{title ?? 'Conteúdo'}</h5>
                        </div>
                    </div>
                    <br />
                </div>

                {loading ? (
                    <li className="list-group-item d-flex justify-content-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Carregando...</span>
                        </div>
                    </li>
                ) : (
                    <>
                        {arquivosPaginados.map(arquivo => {
                            const ativo = String(arquivo.arquivoID) === arquivoID;
                            return (
                                <li key={arquivo.arquivoID} className={`list-group-item menu-lateral-list ${ativo ? 'ativo' : ''}`}>
                                    <Link
                                        to={`/conteudo/${conteudo.conteudoID}/arquivo/${arquivo.arquivoID}`}
                                        className="nav-link menu-lateral-link"
                                        aria-current={ativo ? 'page' : undefined}
                                        tabIndex="0"
                                    >
                                        <i className="bi bi-caret-right-fill menu-lateral-icon"></i>
                                        {`${TipoArquivoLabel[arquivo.tipo]} - ${arquivo.nomeArquivo.length > 25
                                            ? arquivo.nomeArquivo.slice(0, 25) + '...'
                                            : arquivo.nomeArquivo}`}
                                    </Link>
                                </li>
                            );
                        })}

                        {/* Paginação compacta */}
                        {totalPaginas > 1 && (
                            <li className="list-group-item text-center">
                                {gerarPaginas().map((pagina) => (
                                    <button
                                        key={pagina}
                                        onClick={() => setPaginaAtual(pagina)}
                                        className={`btn btn-sm mx-1 ${paginaAtual === pagina ? 'btn-primary' : 'btn-outline-primary'}`}
                                    >
                                        {pagina}
                                    </button>
                                ))}
                            </li>
                        )}

                        <li className="list-group-item">
                            <Link to={`/Treinamentos/${conteudo.tipoConteudo}`} className="nav-link menu-lateral-link">
                                <i className="bi bi-box-arrow-left menu-lateral-icon"></i>
                                Sair
                            </Link>
                        </li>
                    </>
                )}
            </ul>
        </div>
    );
};

export default MenuLateral;